import React, { useContext, useEffect, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import {
  getHistoricoInventario,
  getImagenProductoServer,
  getResumenInventarioRevisado,
} from "../../../API/Inventarios/BodegaMateriales/BodegaMaterialesRequests";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import Card from "../../../Components/Card/Card";
import { baseLang } from "../../../Lang/BaseLang";
import { getLabel } from "../../../Services/Language/LanguageService";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { Button } from "primereact/button";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getImagenProducto } from "../../../API/Global/ProductosSuministros/ProductosSuministrosRequest";
import { Image } from "primereact/image";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import ModalCuentasPorPagarCompras from "../../Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras";
import { getInformacionEncabezadoCXP } from "../../../API/CuentasPorPagar/CXP/CuentasPorPagarRequest";

const InventarioMensualScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [data, setData] = useState([]);
  const [dataHistorico, setDataHistorico] = useState([]);
  const [date, setDate] = useState(new Date());
  const [dialogFactura, setDialogFactura] = useState(false);
  const [IdFactura, setIdFactura] = useState(null);

  const obtenerInformacion = async () => {
    setLoading(true);
    setMostrarDetalle(false);
    let tempoResumen = [];
    if (activeIndex === 0) {
      tempoResumen = await getResumenInventarioRevisado();
      setData(tempoResumen);
    } else if (activeIndex === 1) {
      let year = date.getFullYear();
      let mes = date.getMonth() + 1;
      tempoResumen = await getHistoricoInventario(mes, year);
      setDataHistorico(tempoResumen);
    }
    setLoading(false);
  };

  const habilitarOcultos = () => {
    setMostrarDetalle((prev) => !prev);
  };

  const OpenDocumento = async (rowData) => {

    if (!rowData?.IdCategoriaFinanzas || !rowData?.IdIngresoEnc || !rowData?.NumeroIngreso) return;

    const categoriaMap = {
      1: 1,   // Inv. Suministro
      10: 2,  // Inv. Repuestos
      11: 3,  // Inv. Agujas
      16: 6 || 10   // Inv. Bodega Combustibles y Lubricantes
    };

    const idRef = categoriaMap[rowData.IdCategoriaFinanzas];
    if (!idRef) return;

    let informacionEnviar = {
      IdIngreso: rowData?.IdIngresoEnc,
      IdReferencia: idRef,
      NumeroIngreso: rowData?.NumeroIngreso,
    };

    const tempoCXP = await getInformacionEncabezadoCXP(informacionEnviar);
    if (tempoCXP?.length > 0) {
      setIdFactura(tempoCXP[0]?.Id);
      setDialogFactura(true);
    }
  };

  const hideDialog = () => {
    setDialogFactura(false);
  };

  //Datos Inventario Revisado
  const columns = [
    //PRODUCTO
    {
      header: "Producto",
      headerName: "Producto",
      children: [
        {
          header: "IdProducto",
          headerEn: "",
          field: "IdComponent",
          className: "",
          width: 50,
          hidden: userAuth.IdRol === 1,
          frozen: true,
          alignFrozen: "left",
        },
        {
          field: "Codigo",
          header: "IdIngreso",
          headerEn: "",
          className: "small",
          frozen: true,
          alignFrozen: "left",
        },
        {
          header: "IdDetalle",
          headerEn: "",
          field: "IdDetalle",
          className: "",
          width: 80,
          hidden: userAuth.IdRol === 1,
          frozen: true,
          alignFrozen: "left",
        },

        {
          field: "NumeroIngreso",
          header: "Ingreso",
          headerEn: "Ingreso",
          className: "Xsmall",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "CodigoProducto",
          header: "Codigo",
          className: "small",
          filter: true,
          align: "center",
          frozen: true,
          alignFrozen: "left",
          Sumary: "count",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "NombreProducto",
          header: "Producto",
          className: "Xlarge",
          filter: true,
          align: "center",
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data?.IdIngresoEnc) {
              OpenDocumento(data);
            }
          },
        },
        {
          field: "CategoriaFinanzas",
          header: "Categoria",
          headerEn: "",
          className: "small",
        },
        {
          field: "SubCategoriaFinanzas",
          header: "SubCategoria",
          headerEn: "",
          className: "",
        },

        {
          field: "Estante",
          header: "Estante",
          className: "small",
          filter: true,
          editable: userAuth.IdRol === 1,
          align: "center",
          // frozen: true,
          // alignFrozen: 'left'
        },
        {
          field: "NombreBodega",
          header: "Bodega",
          headerEn: "",
          className: "small",
        },
        {
          field: "Posicion",
          header: "Posicion",
          className: "small",
          filter: true,
          align: "center",
          // frozen: true,
          // alignFrozen: 'left'
        },
        {
          field: "Bandeja",
          header: "Bandeja",
          className: "small",
          filter: true,
          align: "center",
          // frozen: true,
          // alignFrozen: 'left'
        },
        {
          field: "Antiguedad",
          header: "Antiguedad",
          headerEn: "Antiguedad",
          className: "small",
          Format: "Center",
        },
        {
          field: "EstadoAntiguedad",
          header: "Estado Antiguedad",
          headerEn: "EstadoAntiguedad",
          className: "small",
          Format: "Center",
        },
      ],
    },

    //GENERAL
    {
      header: "General",
      headerName: "General",
      children: [
        {
          field: "TipoIngreso",
          header: "Tipo Ingreso",
          className: "small",
          filter: true,
        },
        {
          field: "UnitName",
          header: "Unidad",
          headerEn: "Unit",
          className: "Xsmall",
        },
      ],
    },

    //INICIAL
    {
      header: "Inicial",
      headerName: "Inicial",
      children: [
        {
          field: "Inicial",
          header: "Inicial",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
        },
        {
          field: "InicialPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum'
        },
        {
          field: "InicialMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
        },
        {
          field: "InicialPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum'
        },
        {
          field: "InicialMontoDollar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
        },
      ],
    },

    //Compras
    {
      header: "Compras",
      headerName: "Compras",
      children: [
        {
          field: "Compras",
          header: "Compras",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "PrecioCompraL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "CostoCompraL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
        {
          field: "PrecioCompraD",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "CostoCompraD",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
      ],
    },

    //Ingresos
    {
      header: "Ingresos",
      headerName: "Ingresos",
      children: [
        {
          field: "Ingreso",
          header: "Ingreso",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: !mostrarDetalle,
        },
        {
          field: "IngresoPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: !mostrarDetalle,
        },
        {
          field: "IngresoMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: !mostrarDetalle,
        },
        {
          field: "IngresoPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          // Sumary:'sum',
          hidden: !mostrarDetalle,
        },
        {
          field: "IngresoMontoDollar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: !mostrarDetalle,
        },
      ],
    },

    //Devolucion
    {
      header: "Devolución",
      headerName: "Devolución",
      children: [
        {
          field: "DevolucionesProv",
          header: "Devolucion",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
          // onCellDoubleClicked: ({ data }) => {
          //   if (data?.DevolucionesProv > 0) {
          //     openSalidasInventario(data);
          //   }
          // },
        },
        {
          field: "DevPrecioLps",
          header: "Precio L.",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "DevMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
        {
          field: "DevPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "DevMontoDollar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
      ],
    },

    //Salida
    {
      header: "Salida",
      headerName: "Salida",
      children: [
        {
          field: "Salida",
          header: "Salida",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
          // onCellDoubleClicked: ({ data }) => {
          //   if (data?.SalidasReales > 0) {
          //     openSalidasInventario(data);
          //   }
          // },
        },
        {
          field: "SalidaPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: !mostrarDetalle,
        },
        {
          field: "SalidaMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: !mostrarDetalle,
        },
        {
          field: "SalidaPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: !mostrarDetalle,
        },
        {
          field: "SalidaMontoDollar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: !mostrarDetalle,
        },
      ],
    },

    //Salidas Reales
    {
      header: "Salidas Reales",
      headerName: "Salidas Reales",
      children: [
        {
          field: "SalidasReales",
          header: "Salidas Reales",
          className: "small",
          filter: true,
          Format: "Currency",

          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
          // onCellDoubleClicked:({data}) =>{

          //     if(data?.SalidasReales > 0 || data?.DevolucionesProv > 0){
          //       openSalidasInventario(data)
          //     }
          // }
        },
        {
          field: "SalidaPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "SalidaRealMontoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          hidden: mostrarDetalle,
        },
        {
          field: "SalidaPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "SalidaRealMontoD",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
      ],
    },

    //Devolución Interna
    {
      header: "Devolución Interna",
      headerName: "Devolución Interna",
      children: [
        {
          field: "DevolucionInterna",
          header: "Devolucion",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
        {
          field: "DevolucionPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "DevolucionMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
        {
          field: "DevolucionPrecioDolar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum',
          hidden: mostrarDetalle,
        },
        {
          field: "DevolucionMontoDolar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
          hidden: mostrarDetalle,
        },
      ],
    },

    //Inventario
    {
      header: "Inventario",
      headerName: "Inventario",
      children: [
        {
          field: "InvCalculado",
          header: "Inventario",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
        },
        {
          field: "InventarioPrecioLps",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum'
        },
        {
          field: "InventarioMontoLps",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InventarioPrecioDollar",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // Sumary:'sum'
        },
        {
          field: "InventarioMontoDollar",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          Sumary: "sum",
        },
      ],
    },

    //Inventario Calculado
    {
      header: "Inventario",
      headerName: "Inventario",
      children: [
        {
          field: "Inventario",
          header: "Calculado",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          frozen: true,
          alignFrozen: "right",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DiffInv",
          header: "Diff",
          className: "Xsmall",
          filter: true,
          Format: "Currency",
          // body: (rowData) => rowData.IdComponent > 0 ? diferencia(rowData) : null,
          align: "center",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          frozen: true,
          alignFrozen: "right",
        },
      ],
    },

    // {
    //   header: "Tiene Imagen",
    //   headerEn: "",
    //   field: "TieneImagen",
    //   className: "",
    //   Format: "Checkbox",
    // },

    // {
    //   header: "Accion",
    //   headerName: "Accion",
    //   children: [
    //     {
    //       header: "Imagen",
    //       className: "Xsmall",
    //       Format: "Template",
    //       align: "center",
    //       frozen: "true",
    //       alignFrozen: "right",
    //       body: (rowData) =>
    //         rowData.IdComponent ? (
    //           <Button
    //             icon="pi pi-eye"
    //             className="p-button-text"
    //             style={{ width: 40, marginTop: -10 }}
    //             onClick={() => openDialog(rowData.IdComponent, rowData)}
    //           />
    //         ) : null,
    //     },
    //     // {
    //     //   header: 'Imagen',
    //     //   className: 'Xsmall',
    //     //   Format: "Template",
    //     //   align: "center",
    //     //   frozen: 'true',
    //     //   alignFrozen: 'right',
    //     //   body: (rowData) => rowData.IdComponent ? botones(rowData.IdComponent) : null
    //     // }
    //   ],
    // },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
  };

  //Datos Inventario Historicos
  const columns2 = [
    {
      field: "IdProducto",
      header: "IdProducto",
      headerEn: "",
      className: "Xsmall",
      hidden: userAuth.rol !== 1,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "NumeroIngreso",
      header: "Numero Ingreso",
      headerEn: "Numero Ingreso",
      className: "small",
      Format: "Center",
      // onCellDoubleClicked: ({ data }) => {
      //   if (data.NumeroIngreso) {
      //     setIdIngreso(data?.IdIngresoEnc);
      //     setDialogIngresoBM(true);
      //   }
      // },
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "IdDetalle",
      header: "IdDetalle",
      headerEn: "",
      className: "small",
      hidden: userAuth.rol !== 1,
    },

    {
      field: "IdIngresoDetalle",
      header: "IdDetalle",
      headerEn: "IdDetalle",
      className: "small",
      frozen: true,
      alignFrozen: "left",
      sort: "asc",
    },

    {
      field: "CodigoProducto",
      header: "CodigoProducto",
      className: "medium",
      filter: true,
      Sumary: "count",
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "NombreProducto",
      header: "NombreProducto",
      className: "",
      filter: true,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "TipoIngreso",
      header: "Tipo Ingreso",
      className: "small",
      filter: true,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "Mes",
      header: "Mes",
      className: "Xsmall",
      filter: true,
    },

    {
      field: "Ano",
      header: "Año",
      className: "Xsmall",
      filter: true,
    },
    {
      field: "Antiguedad",
      header: "Antiguedad",
      headerEn: "Antiguedad",
      className: "small",
      Format: "Center",
    },
    {
      field: "EstadoAntiguedad",
      header: "Estado Antiguedad",
      headerEn: "Estado Antiguedad",
      className: "small",
      Format: "Center",
    },

    {
      header: "Inicial",
      headerName: "Inicial",
      children: [
        {
          field: "InicialQty",
          header: "Inicial",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InicialPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InicialCostoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InicialPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InicialCosto",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Ingresos",
      headerName: "Ingresos",
      children: [
        {
          field: "IngresoQty",
          header: "Ingresos",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresoPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresoCostoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresoPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IngresoCosto",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Compras",
      headerName: "Compras",
      children: [
        {
          field: "Compras",
          header: "Ingresos",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComprasPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComprasMontoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComprasPrecioD",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComprasMontoD",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Devoluciones Proveedor",
      headerName: "Devoluciones Proveedor",
      children: [
        {
          field: "DevPQty",
          header: "Devoluciones",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMontoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPPrecio$",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMonto$",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Salida",
      headerName: "Salida",
      children: [
        {
          field: "SalidaQty",
          header: "Salidas",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaCostoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaCosto",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Salida Reales",
      headerName: "Salida",
      children: [
        {
          field: "SalidasReales",
          header: "Salidas",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaRealPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidasRealesMontoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidaRealPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SalidasRealesMontoD",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Devoluciones Internas",
      headerName: "Devoluciones Internas",
      children: [
        {
          field: "DevQty",
          header: "Devoluciones",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevCostoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevCosto",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    {
      header: "Inventario",
      headerName: "Inventario",
      children: [
        {
          field: "InvQty",
          header: "Inventario",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InvPrecioL",
          header: "Precio L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InvCostoL",
          header: "Monto L",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InvPrecio",
          header: "Precio $",
          className: "small",
          filter: true,
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InvCosto",
          header: "Monto $",
          className: "small",
          filter: true,
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: dataHistorico,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "BodegaMateriales", config.language));
    obtenerInformacion();
  }, [activeIndex, date]);

  return (
    <div className="mt-2">
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "BodegaMateriales", config.language)}</h3>
            {activeIndex === 1 && (
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value)}
                view="month"
                dateFormat="mm/yy"
                showIcon
              />
            )}
            <Button
              icon="pi pi-sync"
              className="mx-1"
              onClick={obtenerInformacion}
            />
            <Button icon="pi pi-eye" onClick={habilitarOcultos} />
          </div>
        }
        contenido={
          <div
            className="pt-4"
            style={{ height: "90vh" }}
            id="IngresosCombustibles"
          >
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Inventario Mensual">
                <div
                  className="pt-4"
                  style={{ height: "84vh" }}
                  id="ResumenInventario"
                >
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Historico">
                <div className="pt-4" style={{ height: "84vh" }} id="Historico">
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <ModalCuentasPorPagarCompras
        dialogCuentas={dialogFactura}
        hideDialog={hideDialog}
        IdFactura={IdFactura}
      />
    </div>
  );
};

export default InventarioMensualScreen;
